import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'rosterSelect', 'startsOn', 'endsOn' ]

  rosterSelected(_event) {
    const selectedOption = this.rosterSelectTarget.options[this.rosterSelectTarget.selectedIndex]

    const fpStartsOn = this.startsOnTarget.flatpickr()
    const fpEndsOn = this.endsOnTarget.flatpickr()

    if(!selectedOption.value) {
      fpStartsOn.clear()
      fpEndsOn.clear()

      return
    }

    const startsOnStr = selectedOption.getAttribute('data-starts-on')
    const startsOn = fpStartsOn.parseDate(startsOnStr)

    const dateFormat = fpStartsOn.config.flatpickrDateFormat
    fpStartsOn.setDate(startsOn, true)

    const startsOnFormatted = fpStartsOn.formatDate(startsOn, dateFormat)
    this.startsOnTarget.value = startsOnFormatted

    const endsOnStr = selectedOption.getAttribute('data-ends-on')
    const endsOn = fpEndsOn.parseDate(endsOnStr)

    fpEndsOn.setDate(endsOn)

    const endsOnFormatted = fpEndsOn.formatDate(endsOn, dateFormat)
    this.endsOnTarget.value = endsOnFormatted
  }
}
